// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-m_fs","advertDetailContactGroup__header":"c-m_ft","advertDetailContactGroup__value":"c-m_fu"};